import React from "react";
import { GoGift } from "react-icons/go";
import { PiPaperPlaneTiltBold } from "react-icons/pi";
import { SlArrowRight } from "react-icons/sl";
import { TbBook2 } from "react-icons/tb";

const QuickActions = ({
  setOpenRewards,
  setOpenDeposit,
  setOpenStatement,
}: any) => {
  return (
    <div className="w-full font-manrope bg-white dark:bg-[#1C2227] rounded-xl pt-5 pb-6 px-6">
      <h3 className="font-bold text-paragraph text-[16px] dark:text-gray-200">
        Quick Actions
      </h3>
      <div
        onClick={() => setOpenDeposit(true)}
        className="flex justify-between mt-8 items-center cursor-pointer"
      >
        <div className="flex justify-start items-center gap-4">
          <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
            <PiPaperPlaneTiltBold />
          </div>
          <div>
            <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
              Deposit Funds
            </h4>
            <h4 className="text-gray-500 mt-1 font-medium text-[12px] ">
              Add money or receive crypto
            </h4>
          </div>
        </div>
        <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[14px]" />
      </div>
      <div
        onClick={() => setOpenStatement(true)}
        className="flex justify-between mt-8 items-center cursor-pointer"
      >
        <div className="flex justify-start items-center gap-4">
          <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
            <TbBook2 />
          </div>
          <div>
            <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
              Generate Statement
            </h4>
            <h4 className="text-gray-500   mt-1 font-medium text-[12px] ">
              Download your transaction history{" "}
            </h4>
          </div>
        </div>
        <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[14px]" />
      </div>
      <div
        onClick={() => setOpenRewards(true)}
        className="flex justify-between mt-8 items-center cursor-pointer"
      >
        <div className="flex justify-start items-center gap-4">
          <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
            <GoGift />
          </div>
          <div>
            <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
              Open Reward
            </h4>
            <h4 className="text-gray-500 mt-1 font-medium text-[12px] ">
              See how much you have earned on DeeX
            </h4>
          </div>
        </div>
        <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[14px]" />
      </div>
    </div>
  );
};

export default QuickActions;
